define('extends/Mazarine', [
    'extends/Mazarine.View'
], function(MazarineView) {

    // OVERRIDE BACKBONE FRAMEWORK
    window.Mazarine = {
        View: MazarineView
    };
});
